import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community'
import { AuthProvider } from './contexts/AuthContext'
import { useBrandingStore } from './stores/branding.store'
import { initializeBranding } from './utils/branding'
import App from './App.tsx'
import './index.css'

useBrandingStore.getState().setBranding(initializeBranding())

// Register AG Grid modules globally
ModuleRegistry.registerModules([AllCommunityModule])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
)
